module.exports = __webpack_public_path__ + "img/stoantoniodaalegria.7fad8851.png";